import type {ReactNode} from "react";
import type {PaymentMethod} from "../../../../domain/entities/PaymentMethod";
import {checkoutCopy} from "../../../i18n/checkout/es";
import styles from "../../../pages/checkout/CheckoutPage.module.css";

interface PaymentMethodTransferInfoProps {
    transferInfo?: PaymentMethod["transferInfo"];
    children?: ReactNode;
}

export const PaymentMethodTransferInfo = ({transferInfo, children}: PaymentMethodTransferInfoProps) => {
    if (!transferInfo && !children) {
        return null;
    }

    const infoEntries = (
        [
            [checkoutCopy.payment.transferInfoLabels.bankName, transferInfo?.bankName],
            [checkoutCopy.payment.transferInfoLabels.accountNumber, transferInfo?.accountNumber],
            [checkoutCopy.payment.transferInfoLabels.phoneNumber, transferInfo?.phoneNumber],
            [checkoutCopy.payment.transferInfoLabels.email, transferInfo?.email],
            [checkoutCopy.payment.transferInfoLabels.dni, transferInfo?.dni],
        ] as const
    ).filter(([, value]) => Boolean(value));

    const hasEntries = infoEntries.length > 0;

    if (!hasEntries && !children) {
        return null;
    }

    return (
        <section className={styles.transferInfo} aria-labelledby="transfer-info-title">
            {hasEntries && (
                <>
                    <h3 id="transfer-info-title" className={styles.transferInfoTitle}>
                        {checkoutCopy.payment.transferInfoTitle}
                    </h3>
                    <dl className={styles.transferInfoList}>
                        {infoEntries.map(([label, value]) => (
                            <div key={label} className={styles.transferInfoItem}>
                                <dt>{label}</dt>
                                <dd>{value}</dd>
                            </div>
                        ))}
                    </dl>
                </>
            )}
            {children && <div className={styles.transferExtras}>{children}</div>}
        </section>
    );
};
